import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/settings/company")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace(/^\/settings\/company/, "/settings/general"),
      replace: true,
    })
  },
})
